import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  brands: "/brands",
};

export const fetchBrands = createAsyncThunk(
  "brands/fetchBrands",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.brands, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createBrand = createAsyncThunk(
  "brands/createBrand",
  async (brandsData: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.brands, brandsData);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateBrand = createAsyncThunk(
  "brands/updateBrand",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.brands}/${data.slug}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteBrand = createAsyncThunk(
  "brands/deleteBrand",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.brands}/${slug}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
